import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import HeadsetMicOutlinedIcon from "@material-ui/icons/HeadsetMicOutlined";
import ScheduleOutlinedIcon from "@material-ui/icons/ScheduleOutlined";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import WarningIcon from "@material-ui/icons/Warning";
import TuneIcon from "@material-ui/icons/Tune";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import InputBase from "@material-ui/core/InputBase";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Drawer from "@material-ui/core/Drawer";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsList";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { Button } from "@material-ui/core";
import api from "../../services/api";
import { getTickets } from "../../services/ticketQueries";
import openSocket from "../../services/socket-io";

// Referencia estavel de proposito: array literal em prop cria um objeto novo a
// cada render, e estes entram nas dependencias do efeito que da RESET na
// lista - a lista era limpa logo depois de ser preenchida.
const EMPTY_FILTER_IDS = [];

const useStyles = makeStyles((theme) => ({
  "@keyframes tabPulseGlow": {
    "0%": {
      transform: "translateY(0) scale(1)",
      boxShadow: "0 0 0 rgba(20, 184, 166, 0)",
    },
    "35%": {
      transform: "translateY(-1px) scale(1.01)",
      boxShadow:
        theme.palette.type === "dark"
          ? "0 12px 30px rgba(20, 184, 166, 0.24)"
          : "0 14px 32px rgba(20, 184, 166, 0.22)",
    },
    "100%": {
      transform: "translateY(0) scale(1)",
      boxShadow: "0 0 0 rgba(20, 184, 166, 0)",
    },
  },
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  tabsHeader: {
    flex: "none",
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(19,49,43,0.96) 0%, rgba(11,23,20,0.94) 100%)"
        : "linear-gradient(180deg, rgba(250,255,252,0.98) 0%, rgba(239,248,244,0.92) 100%)",
    borderBottom: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(52, 211, 153, 0.12)"
        : "rgba(18, 140, 126, 0.12)"
    }`,
  },
  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: 8,
  },
  tab: {
    minWidth: 120,
    width: 120,
    minHeight: 68,
    fontWeight: 700,
    letterSpacing: "0.02em",
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background:
      theme.palette.type === "dark"
        ? "rgba(19,49,43,0.86)"
        : "rgba(255,255,255,0.92)",
    padding: theme.spacing(1.25, 1.25, 1),
    borderBottom: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.06)"
        : "rgba(15, 23, 42, 0.06)"
    }`,
    boxShadow:
      theme.palette.type === "dark"
        ? "inset 0 -1px 0 rgba(255,255,255,0.03)"
        : "inset 0 -1px 0 rgba(255,255,255,0.8)",
  },
  serachInputWrapper: {
    flex: 1,
    background: theme.palette.background.paper,
    display: "flex",
    borderRadius: 16,
    padding: "6px 10px",
    marginRight: theme.spacing(1),
    border: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(52, 211, 153, 0.16)"
        : "rgba(18, 140, 126, 0.14)"
    }`,
    boxShadow:
      theme.palette.type === "dark"
        ? "0 8px 18px rgba(2, 6, 23, 0.22)"
        : "0 8px 18px rgba(15, 23, 42, 0.06)",
  },
  searchIcon: {
    color: theme.palette.text.secondary,
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },
  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 12,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
  },
  badge: {
    right: "-12px",
  },
  show: {
    display: "block",
  },
  hide: {
    display: "none !important",
  },
  primaryTabs: {
    minHeight: 0,
    margin: "6px 16px 2px",
    padding: 4,
    borderRadius: 12,
    background:
      theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#eef2f6",
    border: `1px solid ${
      theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#e2e8f0"
    }`,
    "& > div > div": {
      gap: 4,
    },
  },
  primaryTabRoot: {
    flex: 1,
    minWidth: 0,
    minHeight: 36,
    padding: "0 10px",
    borderRadius: 9,
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.85rem",
    letterSpacing: "0.01em",
    color: theme.palette.text.secondary,
    transition: "background-color 160ms ease, box-shadow 160ms ease, color 160ms ease",
    "& > span": {
      flexDirection: "row",
    },
    "&:hover": {
      backgroundColor:
        theme.palette.type === "dark"
          ? "rgba(255,255,255,0.05)"
          : "rgba(15,23,42,0.04)",
    },
    "&.Mui-selected": {
      color: "#ffffff",
      background: "linear-gradient(135deg, #14b8a6 0%, #0f766e 100%)",
      boxShadow: "0 4px 12px -4px rgba(13,148,136,0.5)",
    },
  },
  primaryTabIcon: {
    fontSize: 17,
  },
  primaryTabLabelWrap: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
  },
  primaryTabLabelText: {
    fontWeight: 700,
  },
  primaryTabCounters: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  primaryCounterPill: {
    minWidth: 20,
    height: 20,
    padding: "0 6px",
    borderRadius: 999,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.72rem",
    fontWeight: 800,
    lineHeight: 1,
    color: "#fff",
  },
  primaryCounterPending: {
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, #f59e0b 0%, #d97706 100%)"
        : "linear-gradient(180deg, #fb923c 0%, #f97316 100%)",
  },
  primaryCounterUnread: {
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, #34d399 0%, #059669 100%)"
        : "linear-gradient(180deg, #22c55e 0%, #16a34a 100%)",
  },
  primaryTabAlert: {
    animation: "$tabPulseGlow 1.4s ease",
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(circle at top, rgba(45, 212, 191, 0.22) 0%, rgba(45, 212, 191, 0.08) 45%, rgba(45, 212, 191, 0) 85%)"
        : "radial-gradient(circle at top, rgba(45, 212, 191, 0.26) 0%, rgba(45, 212, 191, 0.12) 45%, rgba(45, 212, 191, 0) 85%)",
  },
  primaryTabAlertSelected: {
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(circle at top, rgba(45, 212, 191, 0.26) 0%, rgba(45, 212, 191, 0.12) 45%, rgba(45, 212, 191, 0.02) 100%)"
        : "radial-gradient(circle at top, rgba(45, 212, 191, 0.3) 0%, rgba(45, 212, 191, 0.14) 45%, rgba(45, 212, 191, 0.02) 100%)",
  },
  secondaryTabs: {
    background:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.02)"
        : "rgba(255,255,255,0.72)",
    borderTop: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.04)"
        : "rgba(255,255,255,0.7)"
    }`,
  },
  secondaryTabRoot: {
    minHeight: 72,
    fontWeight: 700,
    letterSpacing: "0.03em",
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  tabLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: 7,
    lineHeight: 1,
  },
  tabIcon: {
    fontSize: 17,
    flexShrink: 0,
  },
  tabCount: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 18,
    height: 18,
    padding: "0 6px",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 700,
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.10)"
        : "rgba(15,23,42,0.08)",
    color: theme.palette.text.secondary,
  },
  statusTabs: {
    minHeight: 46,
    padding: "10px 12px 6px",
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(20,35,31,0.96) 0%, rgba(11,23,20,0.98) 100%)"
        : "linear-gradient(180deg, rgba(255,255,255,0.94) 0%, rgba(246,248,252,0.96) 100%)",
    borderBottom: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.06)"
        : "rgba(15, 23, 42, 0.06)"
    }`,
  },
  statusTabRoot: {
    minHeight: 46,
    padding: "11px 12px",
    margin: "0 4px",
    borderRadius: 10,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    transition: "background-color 0.15s ease, color 0.15s ease",
    "&:hover": {
      backgroundColor:
        theme.palette.type === "dark"
          ? "rgba(255,255,255,0.05)"
          : "rgba(15,23,42,0.04)",
    },
    "&.Mui-selected": {
      color: "#ffffff",
      backgroundColor: theme.palette.type === "dark" ? "#1f2937" : "#0f1729",
    },
    "&.Mui-selected $tabCount": {
      backgroundColor: "rgba(255,255,255,0.22)",
      color: "#ffffff",
    },
  },
  actionButton: {
    borderRadius: 14,
    padding: "10px 18px",
    fontWeight: 700,
    borderColor: `rgba(${theme.palette.type === "dark" ? "52, 211, 153" : "18, 140, 126"}, 0.25)`,
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(19,49,43,0.98) 0%, rgba(15,36,31,0.98) 100%)"
        : "linear-gradient(180deg, #ffffff 0%, #f6fbf8 100%)",
    boxShadow:
      theme.palette.type === "dark"
        ? "0 10px 20px rgba(2, 6, 23, 0.20)"
        : "0 10px 20px rgba(18, 140, 126, 0.08)",
  },
  connectionAlert: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    background:
      theme.palette.type === "dark"
        ? "rgba(245, 158, 11, 0.12)"
        : "rgba(245, 158, 11, 0.08)",
    borderBottom: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(245, 158, 11, 0.18)"
        : "rgba(245, 158, 11, 0.16)"
    }`,
    color: theme.palette.text.primary,
    fontSize: "0.88rem",
  },
  connectionAlertIcon: {
    fontSize: 18,
    color: theme.palette.warning.main,
    flex: "none",
  },
  filterToggleButton: {
    borderRadius: 14,
    padding: "10px 14px",
    fontWeight: 700,
    minWidth: 0,
    marginLeft: theme.spacing(1),
  },
  activeFiltersSummary: {
    padding: theme.spacing(0, 1.25, 1),
    color: theme.palette.text.secondary,
    fontSize: "0.84rem",
    fontWeight: 600,
  },
  drawerPaper: {
    width: "100%",
    maxWidth: 420,
    padding: theme.spacing(2, 2, 2.5),
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(12,28,24,0.98) 0%, rgba(7,16,14,0.98) 100%)"
        : "linear-gradient(180deg, rgba(255,255,255,0.99) 0%, rgba(246,250,252,0.99) 100%)",
  },
  drawerHeader: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
  },
  drawerTitle: {
    fontSize: "1.1rem",
    fontWeight: 800,
    color: theme.palette.text.primary,
  },
  drawerSubtitle: {
    fontSize: "0.88rem",
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
  advancedFiltersWrap: {
    display: "grid",
    gap: theme.spacing(1.25),
  },
  advancedFiltersGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: theme.spacing(1.25),
    alignItems: "end",
  },
  filterField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 14,
      backgroundColor: theme.palette.background.paper,
    },
  },
  advancedFiltersFooter: {
    marginTop: theme.spacing(1.5),
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: "0.84rem",
  },
  filterHint: {
    color: theme.palette.text.secondary,
  },
  drawerActions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  drawerPrimaryActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    marginLeft: "auto",
  },
}));

const TicketsManager = ({
  forcedTicketType = null,
  hideTicketTypeTabs = false,
}) => {
  const classes = useStyles();
  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const searchInputRef = useRef();
  const { user } = useContext(AuthContext);
  const { whatsApps = [] } = useContext(WhatsAppsContext);
  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [ticketType, setTicketType] = useState(forcedTicketType || "private");
  const userQueueIds = useMemo(
    () => (Array.isArray(user?.queues) ? user.queues.map((q) => q.id) : []),
    [user?.queues]
  );
  const isAdminLikeUser =
    user?.profile?.toUpperCase() === "ADMIN" ||
    Boolean(user?.supportSession?.active) ||
    Boolean(user?.supervisorMode);
  const defaultQueueIds = useMemo(
    () => (isAdminLikeUser ? [] : userQueueIds),
    [isAdminLikeUser, userQueueIds]
  );
  // O admin abre a tela vendo todos os chamados da empresa, como sempre foi,
  // mas a partir dai o controle e dele: desligar passa a mostrar so os
  // chamados atribuidos a ele. Antes o valor era forcado como ligado para
  // admin, o que deixava o proprio botao inerte - clicar nao mudava nada,
  // porque o que ia para a API e o que o Switch exibia liam o valor forcado.
  const showAllScopeKey = `${user?.id || ""}:${isAdminLikeUser}`;
  const showAllInitializedRef = useRef(null);

  useEffect(() => {
    if (!user?.id) return;
    if (showAllInitializedRef.current === showAllScopeKey) return;

    // Reinicializa tambem quando o usuario entra ou sai do Modo suporte, que
    // muda isAdminLikeUser sem trocar o id.
    showAllInitializedRef.current = showAllScopeKey;
    setShowAllTickets(isAdminLikeUser);
  }, [showAllScopeKey, user?.id, isAdminLikeUser]);
  const [selectedQueueIds, setSelectedQueueIds] = useState(defaultQueueIds || []);
  const hasGroupEnabledConnection = useMemo(
    () => whatsApps.some((whatsApp) => whatsApp.allowGroupMessages),
    [whatsApps]
  );
  const shouldForceTicketTypeTabsForUser =
    user?.profile?.toLowerCase() === "user";
  const shouldShowTicketTypeTabs =
    !hideTicketTypeTabs &&
    (Boolean(forcedTicketType) ||
      hasGroupEnabledConnection ||
      shouldForceTicketTypeTabsForUser);
  const [privatePendingCount, setPrivatePendingCount] = useState(0);
  const [groupPendingCount, setGroupPendingCount] = useState(0);
  const [privateUnreadCount, setPrivateUnreadCount] = useState(0);
  const [groupUnreadCount, setGroupUnreadCount] = useState(0);
  const [whatsAppHealth, setWhatsAppHealth] = useState(null);
  const [advancedFiltersOpen, setAdvancedFiltersOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTicketId, setSelectedTicketId] = useState("");
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedWhatsAppId, setSelectedWhatsAppId] = useState("");
  const [selectedTagValues, setSelectedTagValues] = useState([]);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("active");
  const [draftSelectedQueueIds, setDraftSelectedQueueIds] = useState(defaultQueueIds || []);
  const [draftSelectedDate, setDraftSelectedDate] = useState("");
  const [draftSelectedTicketId, setDraftSelectedTicketId] = useState("");
  const [draftSelectedUserId, setDraftSelectedUserId] = useState("");
  const [draftSelectedWhatsAppId, setDraftSelectedWhatsAppId] = useState("");
  const [draftSelectedTagValues, setDraftSelectedTagValues] = useState([]);
  const [draftSelectedStatusFilter, setDraftSelectedStatusFilter] = useState("active");
  const [filterOptions, setFilterOptions] = useState({
    users: [],
    queues: [],
    whatsapps: [],
    tags: []
  });
  const [tabActivity, setTabActivity] = useState({
    private: false,
    group: false
  });
  const [ticketsRealtimeRefreshToken, setTicketsRealtimeRefreshToken] = useState(0);
  const pendingCounterRequestIdRef = useRef(0);
  const unreadCounterRequestIdRef = useRef(0);
  const tabActivityTimeoutsRef = useRef({});
  const recentTabMessageIdsRef = useRef(new Set());
  const ticketsRefreshTimeoutRef = useRef(null);

  const selectedUserIds = useMemo(
    () => (selectedUserId ? [Number(selectedUserId)] : []),
    [selectedUserId]
  );
  const selectedWhatsAppIds = useMemo(
    () => (selectedWhatsAppId ? [Number(selectedWhatsAppId)] : []),
    [selectedWhatsAppId]
  );
  const selectedTagIds = useMemo(
    () =>
      selectedTagValues
        .map(value => Number(value))
        .filter(value => !Number.isNaN(value)),
    [selectedTagValues]
  );
  const availableQueues = useMemo(
    () =>
      Array.isArray(filterOptions.queues) && filterOptions.queues.length
        ? filterOptions.queues
        : user?.queues || [],
    [filterOptions.queues, user?.queues]
  );
  const defaultQueueIdsKey = useMemo(
    () => JSON.stringify([...(defaultQueueIds || [])].sort((left, right) => left - right)),
    [defaultQueueIds]
  );
  const selectedQueueIdsKey = useMemo(
    () => JSON.stringify([...(selectedQueueIds || [])].sort((left, right) => left - right)),
    [selectedQueueIds]
  );
  const hasQueueFilterChanged = selectedQueueIdsKey !== defaultQueueIdsKey;
  const requestQueueIds = useMemo(
    () => (hasQueueFilterChanged ? selectedQueueIds : []),
    [hasQueueFilterChanged, selectedQueueIds]
  );
  const queueIdsParam = JSON.stringify(requestQueueIds);
  const hasAdvancedFiltersApplied = Boolean(
    selectedTicketId ||
      selectedDate ||
      selectedUserId ||
      selectedWhatsAppId ||
      selectedTagValues.length > 0 ||
      hasQueueFilterChanged ||
      selectedStatusFilter !== "active"
  );
  // Buscar por id ignora os demais recortes (ver o bloco de render): contar os
  // outros aqui prometeria um filtro que nao esta valendo.
  const activeAdvancedFiltersCount = selectedTicketId
    ? 1
    : (selectedDate ? 1 : 0) +
      (selectedUserId ? 1 : 0) +
      (selectedWhatsAppId ? 1 : 0) +
      (selectedTagValues.length > 0 ? 1 : 0) +
      (hasQueueFilterChanged ? 1 : 0) +
      (selectedStatusFilter !== "active" ? 1 : 0);

  useEffect(() => {
    if (isAdminLikeUser) {
      setShowAllTickets(true);
    }
  }, [isAdminLikeUser]);

  useEffect(() => {
    setSelectedQueueIds(defaultQueueIds || []);
    setDraftSelectedQueueIds(defaultQueueIds || []);
  }, [defaultQueueIdsKey, user?.id]);

  useEffect(() => {
    if (forcedTicketType) {
      setTicketType(forcedTicketType);
    }
  }, [forcedTicketType]);

  useEffect(() => {
    if (
      !forcedTicketType &&
      !hasGroupEnabledConnection &&
      !shouldForceTicketTypeTabsForUser &&
      ticketType === "group"
    ) {
      setTicketType("private");
    }
  }, [
    forcedTicketType,
    hasGroupEnabledConnection,
    shouldForceTicketTypeTabsForUser,
    ticketType
  ]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
      setSearchParam("");
    }
  }, [tab]);

  const refreshWhatsAppHealth = useCallback(async () => {
    try {
      const { data } = await api.get("/whatsapp/health", {
        params: { _: Date.now() }
      });
      setWhatsAppHealth(data);
    } catch (error) {
      setWhatsAppHealth(null);
    }
  }, []);

  useEffect(() => {
    refreshWhatsAppHealth();
  }, [refreshWhatsAppHealth]);

  const refreshFilterOptions = useCallback(async () => {
    try {
      const { data } = await api.get("/tickets/filter-options", {
        params: { _: Date.now() }
      });
      setFilterOptions({
        users: Array.isArray(data?.users) ? data.users : [],
        queues: Array.isArray(data?.queues) ? data.queues : [],
        whatsapps: Array.isArray(data?.whatsapps) ? data.whatsapps : [],
        tags: Array.isArray(data?.tags) ? data.tags : []
      });
    } catch (error) {
      setFilterOptions({
        users: [],
        queues: [],
        whatsapps: [],
        tags: []
      });
    }
  }, []);

  useEffect(() => {
    refreshFilterOptions();
  }, [refreshFilterOptions]);

  useEffect(() => {
    const socket = openSocket();

    socket.on("whatsappSession", () => {
      refreshWhatsAppHealth();
    });

    socket.on("whatsapp", () => {
      refreshWhatsAppHealth();
    });

    return () => {
      socket.disconnect();
    };
  }, [refreshWhatsAppHealth]);

  useEffect(() => {
    return () => {
      Object.values(tabActivityTimeoutsRef.current).forEach(timeoutId => {
        clearTimeout(timeoutId);
      });
      if (ticketsRefreshTimeoutRef.current) {
        clearTimeout(ticketsRefreshTimeoutRef.current);
      }
    };
  }, []);

  const refreshPendingCounters = useCallback(async () => {
    const requestId = ++pendingCounterRequestIdRef.current;
    try {
      const commonParams = {
        pageNumber: 1,
        status: "pending",
        countOnly: "true",
        showAll: showAllTickets,
        queueIds: queueIdsParam,
        userIds: JSON.stringify(selectedUserIds),
        whatsappIds: JSON.stringify(selectedWhatsAppIds),
        tagIds: JSON.stringify(selectedTagIds),
        date: selectedDate || undefined,
        ticketId: selectedTicketId || undefined
      };

      const [privateResponse, groupResponse] = await Promise.all([
        getTickets({
          ...commonParams,
          ticketType: "private"
        }),
        getTickets({
          ...commonParams,
          ticketType: "group"
        })
      ]);

      if (requestId !== pendingCounterRequestIdRef.current) {
        return;
      }

      setPrivatePendingCount(privateResponse.data.count || 0);
      setGroupPendingCount(groupResponse.data.count || 0);
    } catch (error) {
      if (requestId !== pendingCounterRequestIdRef.current) {
        return;
      }
      setPrivatePendingCount(0);
      setGroupPendingCount(0);
    }
  }, [
    queueIdsParam,
    selectedDate,
    selectedTicketId,
    selectedUserIds,
    selectedWhatsAppIds,
    selectedTagIds,
    showAllTickets
  ]);

  useEffect(() => {
    refreshPendingCounters();
  }, [refreshPendingCounters]);

  const refreshUnreadCounters = useCallback(async () => {
    const requestId = ++unreadCounterRequestIdRef.current;
    try {
      const commonParams = {
        pageNumber: 1,
        status: "open",
        countOnly: "true",
        withUnreadMessages: "true",
        assignedOnlyUnread: "true"
      };

      const [privateResponse, groupResponse] = await Promise.all([
        getTickets({
          ...commonParams,
          ticketType: "private"
        }),
        getTickets({
          ...commonParams,
          ticketType: "group"
        })
      ]);

      if (requestId !== unreadCounterRequestIdRef.current) {
        return;
      }

      setPrivateUnreadCount(privateResponse.data.count || 0);
      setGroupUnreadCount(groupResponse.data.count || 0);
    } catch (error) {
      if (requestId !== unreadCounterRequestIdRef.current) {
        return;
      }
      setPrivateUnreadCount(0);
      setGroupUnreadCount(0);
    }
  }, []);

  useEffect(() => {
    refreshUnreadCounters();
  }, [refreshUnreadCounters]);

  const triggerTicketTypeActivity = useCallback(type => {
    if (!["private", "group"].includes(type)) {
      return;
    }

    setTabActivity(prevState => ({
      ...prevState,
      [type]: false
    }));

    window.clearTimeout(tabActivityTimeoutsRef.current[type]);

    window.requestAnimationFrame(() => {
      setTabActivity(prevState => ({
        ...prevState,
        [type]: true
      }));
    });

    tabActivityTimeoutsRef.current[type] = window.setTimeout(() => {
      setTabActivity(prevState => ({
        ...prevState,
        [type]: false
      }));
    }, 3200);
  }, []);

  useEffect(() => {
    const socket = openSocket();
    let unreadRefreshTimeoutId = null;
    let pendingRefreshTimeoutId = null;
    let ticketsRefreshTimeoutId = null;

    const scheduleUnreadRefresh = () => {
      if (unreadRefreshTimeoutId) {
        window.clearTimeout(unreadRefreshTimeoutId);
      }

      unreadRefreshTimeoutId = window.setTimeout(() => {
        refreshUnreadCounters();
      }, 220);
    };

    const schedulePendingRefresh = () => {
      if (pendingRefreshTimeoutId) {
        window.clearTimeout(pendingRefreshTimeoutId);
      }

      pendingRefreshTimeoutId = window.setTimeout(() => {
        refreshPendingCounters();
      }, 220);
    };

    const scheduleTicketsRefresh = () => {
      if (ticketsRefreshTimeoutId) {
        window.clearTimeout(ticketsRefreshTimeoutId);
      }

      ticketsRefreshTimeoutId = window.setTimeout(() => {
        setTicketsRealtimeRefreshToken(prevState => prevState + 1);
      }, 180);
    };

    const rememberMessageKey = messageKey => {
      if (!messageKey) {
        return false;
      }

      if (recentTabMessageIdsRef.current.has(messageKey)) {
        return true;
      }

      recentTabMessageIdsRef.current.add(messageKey);
      window.setTimeout(() => {
        recentTabMessageIdsRef.current.delete(messageKey);
      }, 5000);

      return false;
    };

    const resolveTicketType = ticket => {
      if (!ticket) {
        return null;
      }

      return ticket.isGroup ? "group" : "private";
    };

    const maybeTriggerActivity = (ticket, messageKey) => {
      const resolvedType = resolveTicketType(ticket);

      if (!resolvedType || rememberMessageKey(messageKey)) {
        return;
      }

      triggerTicketTypeActivity(resolvedType);
    };

    socket.on("connect", () => {
      socket.emit("joinNotification");
      socket.emit("joinTickets", "pending");
      socket.emit("joinTickets", "open");
      scheduleUnreadRefresh();
      schedulePendingRefresh();
    });

    socket.on("appMessage", data => {
      if (data?.action === "create" && !data?.message?.read) {
        maybeTriggerActivity(data.ticket, data.message?.id);
        scheduleUnreadRefresh();
      }
    });

    socket.on("ticket", data => {
      if (data?.action === "update" && data?.meta?.source === "message") {
        maybeTriggerActivity(data.ticket, data.meta?.messageId);
        scheduleUnreadRefresh();
        return;
      }

      if (["update", "updateUnread", "create", "delete"].includes(data?.action)) {
        scheduleUnreadRefresh();
        schedulePendingRefresh();
        scheduleTicketsRefresh();
      }
    });

    socket.on("ticketTransfer", data => {
      if (!data?.ticket) {
        return;
      }

      const transferKey = `transfer:${data.ticket.id}:${data.ticket.updatedAt || data.ticket.updated_at || ""}`;
      maybeTriggerActivity(data.ticket, transferKey);
      scheduleUnreadRefresh();
      schedulePendingRefresh();
      scheduleTicketsRefresh();
    });

    return () => {
      if (unreadRefreshTimeoutId) {
        window.clearTimeout(unreadRefreshTimeoutId);
      }
      if (pendingRefreshTimeoutId) {
        window.clearTimeout(pendingRefreshTimeoutId);
      }
      if (ticketsRefreshTimeoutId) {
        window.clearTimeout(ticketsRefreshTimeoutId);
      }
      socket.disconnect();
    };
  }, [refreshPendingCounters, refreshUnreadCounters, triggerTicketTypeActivity]);

  const getPrimaryTabClassName = useCallback(
    type => {
      const classNames = [classes.primaryTabRoot];

      if (tabActivity[type]) {
        classNames.push(classes.primaryTabAlert);
        if (ticketType === type) {
          classNames.push(classes.primaryTabAlertSelected);
        }
      }

      return classNames.join(" ");
    },
    [classes.primaryTabAlert, classes.primaryTabAlertSelected, classes.primaryTabRoot, tabActivity, ticketType]
  );

  const renderTicketTypeLabel = useCallback(
    (icon, label, pendingValue, unreadValue) => (
      <span className={classes.primaryTabLabelWrap}>
        {icon}
        <span className={classes.primaryTabLabelText}>{label}</span>
        <span className={classes.primaryTabCounters}>
          {pendingValue > 0 ? (
            <span className={`${classes.primaryCounterPill} ${classes.primaryCounterPending}`}>
              {pendingValue}
            </span>
          ) : null}
          {unreadValue > 0 ? (
            <span className={`${classes.primaryCounterPill} ${classes.primaryCounterUnread}`}>
              {unreadValue}
            </span>
          ) : null}
        </span>
      </span>
    ),
    [
      classes.primaryCounterPending,
      classes.primaryCounterPill,
      classes.primaryCounterUnread,
      classes.primaryTabCounters,
      classes.primaryTabLabelText,
      classes.primaryTabLabelWrap
    ]
  );

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setTab("open");
      return;
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
    }, 500);
  };

  const handleChangeTabOpen = (e, newValue) => {
    setTabOpen(newValue);
  };

  useEffect(() => {
    const handleMoveTicketToOpenView = event => {
      const movedTicket = event?.detail?.ticket;
      const movedTicketStatus = String(movedTicket?.status || "").toLowerCase();
      const requestedStatus = String(event?.detail?.requestedStatus || "").toLowerCase();
      const previousStatus = String(event?.detail?.previousStatus || "").toLowerCase();
      const isAcceptEvent = event?.type === "ticket:accepted";
      const shouldOpenView =
        isAcceptEvent ||
        (movedTicketStatus === "open" &&
          requestedStatus === "open" &&
          previousStatus !== "open");

      if (!movedTicket?.id || !shouldOpenView) {
        return;
      }

      if (tab === "search") {
        setSearchParam("");
        setTab("open");
      }

      setTabOpen("open");
      setSelectedStatusFilter(prevStatus =>
        prevStatus === "active" ? "active" : "open"
      );
    };

    window.addEventListener("ticket:accepted", handleMoveTicketToOpenView);
    window.addEventListener("ticket:updated", handleMoveTicketToOpenView);

    return () => {
      window.removeEventListener("ticket:accepted", handleMoveTicketToOpenView);
      window.removeEventListener("ticket:updated", handleMoveTicketToOpenView);
    };
  }, [tab]);

  useEffect(() => {
    const handleTicketCountersRefresh = () => {
      refreshUnreadCounters();
      refreshPendingCounters();

      if (ticketsRefreshTimeoutRef.current) {
        clearTimeout(ticketsRefreshTimeoutRef.current);
      }

      ticketsRefreshTimeoutRef.current = setTimeout(() => {
        setTicketsRealtimeRefreshToken(prevState => prevState + 1);
        ticketsRefreshTimeoutRef.current = null;
      }, 120);
    };

    window.addEventListener("ticket:accepted", handleTicketCountersRefresh);
    window.addEventListener("ticket:updated", handleTicketCountersRefresh);

    return () => {
      window.removeEventListener("ticket:accepted", handleTicketCountersRefresh);
      window.removeEventListener("ticket:updated", handleTicketCountersRefresh);
    };
  }, [refreshPendingCounters, refreshUnreadCounters]);

  const connectionAlertMessage = useMemo(() => {
    if (!whatsAppHealth?.hasIssue) {
      return "";
    }

    const suffixKey =
      user?.profile?.toLowerCase() === "user"
        ? "ticketsManager.connectionAlert.notifyAdmin"
        : "ticketsManager.connectionAlert.checkConnections";

    const stateKeyMap = {
      no_connections: "ticketsManager.connectionAlert.noConnections",
      qrcode: "ticketsManager.connectionAlert.qrcode",
      connecting: "ticketsManager.connectionAlert.connecting"
    };

    const messageKey = stateKeyMap[whatsAppHealth.state] || "ticketsManager.connectionAlert.inactive";

    return `${i18n.t(messageKey)} ${i18n.t(suffixKey)}`;
  }, [whatsAppHealth, user?.profile, i18n.language]);

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { display: "none", pointerEvents: "none" };
    }

    return { display: "flex" };
  };

  const syncDraftFiltersFromApplied = useCallback(() => {
    setDraftSelectedQueueIds(selectedQueueIds || []);
    setDraftSelectedDate(selectedDate);
    setDraftSelectedTicketId(selectedTicketId);
    setDraftSelectedUserId(selectedUserId);
    setDraftSelectedWhatsAppId(selectedWhatsAppId);
    setDraftSelectedTagValues(selectedTagValues);
    setDraftSelectedStatusFilter(selectedStatusFilter);
  }, [
    selectedDate,
    selectedTicketId,
    selectedQueueIds,
    selectedTagValues,
    selectedUserId,
    selectedWhatsAppId,
    selectedStatusFilter
  ]);

  const handleOpenAdvancedFilters = () => {
    syncDraftFiltersFromApplied();
    setAdvancedFiltersOpen(true);
  };

  const handleCloseAdvancedFilters = () => {
    setAdvancedFiltersOpen(false);
  };

  const handleResetDraftAdvancedFilters = () => {
    setDraftSelectedQueueIds(defaultQueueIds || []);
    setDraftSelectedDate("");
    setDraftSelectedTicketId("");
    setDraftSelectedUserId("");
    setDraftSelectedWhatsAppId("");
    setDraftSelectedTagValues([]);
    setDraftSelectedStatusFilter("active");
  };

  const handleApplyAdvancedFilters = () => {
    setSelectedQueueIds(draftSelectedQueueIds || []);
    setSelectedDate(draftSelectedDate);
    setSelectedTicketId(draftSelectedTicketId);
    setSelectedUserId(draftSelectedUserId);
    setSelectedWhatsAppId(draftSelectedWhatsAppId);
    setSelectedTagValues(draftSelectedTagValues);
    setSelectedStatusFilter(draftSelectedStatusFilter || "active");
    setTabOpen(prevStatus =>
      ["open", "pending"].includes(draftSelectedStatusFilter) ? draftSelectedStatusFilter : prevStatus
    );
    setAdvancedFiltersOpen(false);
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(e) => setNewTicketModalOpen(false)}
      />
      <Paper elevation={0} square className={classes.tabsHeader}>
        {shouldShowTicketTypeTabs && (
          <Tabs
            value={ticketType}
            onChange={(e, newValue) => setTicketType(newValue)}
            variant="fullWidth"
            aria-label="conversation type tabs"
            className={classes.primaryTabs}
            TabIndicatorProps={{ style: { display: "none" } }}
          >
            <Tab
              value="private"
              label={renderTicketTypeLabel(
                <ChatBubbleOutlineIcon className={classes.primaryTabIcon} />,
                i18n.t("ticketsManager.tabs.private"),
                privatePendingCount,
                privateUnreadCount
              )}
              className={getPrimaryTabClassName("private")}
              classes={{ root: classes.primaryTabRoot }}
            />
            <Tab
              value="group"
              label={renderTicketTypeLabel(
                <GroupOutlinedIcon className={classes.primaryTabIcon} />,
                i18n.t("ticketsManager.tabs.group"),
                groupPendingCount,
                groupUnreadCount
              )}
              className={getPrimaryTabClassName("group")}
              classes={{ root: classes.primaryTabRoot }}
            />
          </Tabs>
        )}
      </Paper>
      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        {tab === "search" ? (
          <div className={classes.serachInputWrapper}>
            <SearchIcon className={classes.searchIcon} />
            <InputBase
              className={classes.searchInput}
              inputRef={searchInputRef}
              placeholder={i18n.t("tickets.search.placeholder")}
              type="search"
              onChange={handleSearch}
            />
          </div>
        ) : (
          <>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setNewTicketModalOpen(true)}
              className={classes.actionButton}
              startIcon={<AddIcon />}
            >
              {i18n.t("ticketsManager.buttons.newTicket")}
            </Button>
            {isAdminLikeUser && (
                <FormControlLabel
                  label={i18n.t("tickets.buttons.showAll")}
                  labelPlacement="start"
                  control={
                    <Switch
                      size="small"
                      checked={showAllTickets}
                      onChange={() =>
                        setShowAllTickets((prevState) => !prevState)
                      }
                      name="showAllTickets"
                      color="primary"
                    />
                  }
                />
            )}
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setTab("search")}
              className={classes.filterToggleButton}
              startIcon={<SearchIcon />}
            >
              {i18n.t("ticketsManager.buttons.search")}
            </Button>
          </>
        )}
        <Button
          variant={advancedFiltersOpen || hasAdvancedFiltersApplied ? "contained" : "outlined"}
          color="primary"
          onClick={handleOpenAdvancedFilters}
          className={classes.filterToggleButton}
          startIcon={<TuneIcon />}
        >
          {activeAdvancedFiltersCount > 0
            ? `${i18n.t("ticketsManager.buttons.filters")} (${activeAdvancedFiltersCount})`
            : i18n.t("ticketsManager.buttons.filters")}
        </Button>
      </Paper>
      {hasAdvancedFiltersApplied && (
        <div className={classes.activeFiltersSummary}>
          {i18n.t(
            activeAdvancedFiltersCount > 1
              ? "ticketsManager.activeFiltersSummary.plural"
              : "ticketsManager.activeFiltersSummary.singular",
            { count: activeAdvancedFiltersCount }
          )}
        </div>
      )}
      <Drawer
        anchor="right"
        open={advancedFiltersOpen}
        onClose={handleCloseAdvancedFilters}
        classes={{ paper: classes.drawerPaper }}
      >
        <div className={classes.drawerHeader}>
          <span className={classes.drawerTitle}>{i18n.t("ticketsManager.filters.title")}</span>
          <span className={classes.drawerSubtitle}>
            {i18n.t("ticketsManager.filters.subtitle")}
          </span>
        </div>
        <div className={classes.advancedFiltersWrap}>
          <div className={classes.advancedFiltersGrid}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label={i18n.t("ticketsManager.filters.ticketId")}
              className={classes.filterField}
              value={draftSelectedTicketId}
              onChange={(event) =>
                setDraftSelectedTicketId(event.target.value.replace(/\D/g, ""))
              }
              inputProps={{ inputMode: "numeric" }}
              placeholder={i18n.t("ticketsManager.filters.ticketIdPlaceholder")}
            />
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label={i18n.t("ticketsManager.filters.status")}
              className={classes.filterField}
              value={draftSelectedStatusFilter}
              onChange={(event) => setDraftSelectedStatusFilter(event.target.value)}
            >
              <MenuItem value="active">{i18n.t("ticketsManager.filters.statusOptions.active")}</MenuItem>
              <MenuItem value="open">{i18n.t("ticketsManager.filters.statusOptions.open")}</MenuItem>
              <MenuItem value="pending">{i18n.t("ticketsManager.filters.statusOptions.pending")}</MenuItem>
              <MenuItem value="closed">{i18n.t("ticketsManager.filters.statusOptions.closed")}</MenuItem>
            </TextField>
            <TicketsQueueSelect
              selectedQueueIds={draftSelectedQueueIds}
              userQueues={availableQueues}
              onChange={(values) => setDraftSelectedQueueIds(values)}
            />
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label={i18n.t("ticketsManager.filters.agent")}
              className={classes.filterField}
              value={draftSelectedUserId}
              onChange={(event) => setDraftSelectedUserId(event.target.value)}
            >
              <MenuItem value="">{i18n.t("ticketsManager.filters.all")}</MenuItem>
              {filterOptions.users.map((option) => (
                <MenuItem key={option.id} value={String(option.id)}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label={i18n.t("ticketsManager.filters.connection")}
              className={classes.filterField}
              value={draftSelectedWhatsAppId}
              onChange={(event) => setDraftSelectedWhatsAppId(event.target.value)}
            >
              <MenuItem value="">{i18n.t("ticketsManager.filters.allFemale")}</MenuItem>
              {filterOptions.whatsapps.map((option) => (
                <MenuItem key={option.id} value={String(option.id)}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label={i18n.t("ticketsManager.filters.date")}
              type="date"
              className={classes.filterField}
              value={draftSelectedDate}
              onChange={(event) => setDraftSelectedDate(event.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <FormControl
              fullWidth
              size="small"
              variant="outlined"
              className={classes.filterField}
            >
              <InputLabel id="tickets-tag-filter-label">Tags</InputLabel>
              <Select
                labelId="tickets-tag-filter-label"
                multiple
                value={draftSelectedTagValues}
                onChange={(event) => setDraftSelectedTagValues(event.target.value)}
                label="Tags"
                renderValue={(selected) => {
                  if (!selected.length) {
                    return i18n.t("ticketsManager.filters.allFemale");
                  }

                  return filterOptions.tags
                    .filter((tag) => selected.includes(String(tag.id)))
                    .map((tag) => tag.name)
                    .join(", ");
                }}
              >
                {filterOptions.tags.map((option) => (
                  <MenuItem key={option.id} value={String(option.id)}>
                    <Chip
                      size="small"
                      label={option.name}
                      style={{
                        backgroundColor: `${option.color}22`,
                        color: option.color,
                        fontWeight: 700
                      }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className={classes.advancedFiltersFooter}>
            <span className={classes.filterHint}>
              {i18n.t("ticketsManager.filters.hint")}
            </span>
            <div className={classes.drawerActions}>
              <Button
                color="primary"
                size="small"
                startIcon={<ClearAllIcon />}
                onClick={handleResetDraftAdvancedFilters}
              >
                {i18n.t("ticketsManager.filters.clear")}
              </Button>
              <div className={classes.drawerPrimaryActions}>
                <Button onClick={handleCloseAdvancedFilters}>
                  {i18n.t("ticketsManager.filters.cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleApplyAdvancedFilters}
                >
                  {i18n.t("ticketsManager.filters.apply")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
      {connectionAlertMessage && (
        <div className={classes.connectionAlert}>
          <WarningIcon className={classes.connectionAlertIcon} />
          <span>{connectionAlertMessage}</span>
        </div>
      )}
      {selectedTicketId ? (
        // O id identifica UM chamado. Aplicar status, fila, atendente, conexao,
        // data e tags por cima so serviria para esconde-lo: quem digita o numero
        // ja sabe qual quer, e o caso comum e justamente procurar um chamado
        // resolvido enquanto a tela esta em "Ativos". O recorte de visibilidade
        // continua sendo do servidor - showAll so vale para admin.
        <TicketsList
          showAll={true}
          ticketType="all"
          selectedQueueIds={EMPTY_FILTER_IDS}
          requestQueueIds={EMPTY_FILTER_IDS}
          selectedUserIds={EMPTY_FILTER_IDS}
          selectedWhatsAppIds={EMPTY_FILTER_IDS}
          selectedTagIds={EMPTY_FILTER_IDS}
          selectedDate=""
          selectedTicketId={selectedTicketId}
          refreshTrigger={ticketsRealtimeRefreshToken}
        />
      ) : tab === "search" ? (
        <TicketsList
          searchParam={searchParam}
          status={selectedStatusFilter !== "active" ? selectedStatusFilter : undefined}
          showAll={true}
          ticketType={ticketType}
          selectedQueueIds={selectedQueueIds}
          requestQueueIds={requestQueueIds}
          selectedUserIds={selectedUserIds}
          selectedWhatsAppIds={selectedWhatsAppIds}
          selectedTagIds={selectedTagIds}
          selectedDate={selectedDate}
          selectedTicketId={selectedTicketId}
          refreshTrigger={ticketsRealtimeRefreshToken}
        />
      ) : selectedStatusFilter === "active" ? (
        <>
          <Tabs
            value={tabOpen}
            onChange={handleChangeTabOpen}
            textColor="primary"
            variant="fullWidth"
            className={classes.statusTabs}
            TabIndicatorProps={{ style: { display: "none" } }}
          >
            <Tab
              label={
                <span className={classes.tabLabel}>
                  <HeadsetMicOutlinedIcon className={classes.tabIcon} />
                  {i18n.t("ticketsList.assignedHeader")}
                  <span className={classes.tabCount}>{openCount || 0}</span>
                </span>
              }
              value={"open"}
              classes={{ root: classes.statusTabRoot }}
            />
            <Tab
              label={
                <span className={classes.tabLabel}>
                  <ScheduleOutlinedIcon className={classes.tabIcon} />
                  {i18n.t("ticketsList.pendingHeader")}
                  <span className={classes.tabCount}>{pendingCount || 0}</span>
                </span>
              }
              value={"pending"}
              classes={{ root: classes.statusTabRoot }}
            />
          </Tabs>
          <Paper className={classes.ticketsWrapper}>
            <TicketsList
              status="open"
              showAll={showAllTickets}
              ticketType={ticketType}
              selectedQueueIds={selectedQueueIds}
              requestQueueIds={requestQueueIds}
              selectedUserIds={selectedUserIds}
              selectedWhatsAppIds={selectedWhatsAppIds}
              selectedTagIds={selectedTagIds}
              selectedDate={selectedDate}
              selectedTicketId={selectedTicketId}
              refreshTrigger={ticketsRealtimeRefreshToken}
              updateCount={(val) => setOpenCount(val)}
              style={applyPanelStyle("open")}
            />
            <TicketsList
              status="pending"
              showAll={showAllTickets}
              ticketType={ticketType}
              selectedQueueIds={selectedQueueIds}
              requestQueueIds={requestQueueIds}
              selectedUserIds={selectedUserIds}
              selectedWhatsAppIds={selectedWhatsAppIds}
              selectedTagIds={selectedTagIds}
              selectedDate={selectedDate}
              selectedTicketId={selectedTicketId}
              refreshTrigger={ticketsRealtimeRefreshToken}
              updateCount={(val) => setPendingCount(val)}
              style={applyPanelStyle("pending")}
            />
          </Paper>
        </>
      ) : (
        <TicketsList
          status={selectedStatusFilter}
          showAll={selectedStatusFilter === "closed" ? true : showAllTickets}
          ticketType={ticketType}
          selectedQueueIds={selectedQueueIds}
          requestQueueIds={requestQueueIds}
          selectedUserIds={selectedUserIds}
          selectedWhatsAppIds={selectedWhatsAppIds}
          selectedTagIds={selectedTagIds}
          selectedDate={selectedDate}
          selectedTicketId={selectedTicketId}
          refreshTrigger={ticketsRealtimeRefreshToken}
          updateCount={(val) => {
            if (selectedStatusFilter === "open") setOpenCount(val);
            if (selectedStatusFilter === "pending") setPendingCount(val);
          }}
        />
      )}
    </Paper>
  );
};

export default TicketsManager;
